const bytesToMegaBytes = (bytes: number) => bytes / (1024 * 1024);
const bytesToGigaBytes = (bytes: number) => bytes / Math.pow(10, 9);

export { bytesToMegaBytes, bytesToGigaBytes };
